import React from 'react';
import { bool, func } from 'prop-types';
import classnames from 'classnames';
import { ButtonIcon } from '../../icon';
import TableCell from './cell';

const ExpandCell = ({ expanded, toggleExpand, className, ...props }) => (
  <TableCell
    className={classnames(
      className,
      'mdl-data-table__cell--collapse-btn',
    )}
    {...props}
  >
    <ButtonIcon
      onClick={toggleExpand}
    >
      {expanded ? 'expand_less' : 'expand_more'}
    </ButtonIcon>
  </TableCell>
);

ExpandCell.propTypes = {
  expanded: bool,
  toggleExpand: func.isRequired,
};

ExpandCell.defaultProps = {
  expanded: false,
};

export default ExpandCell;
